import type { RosterFarmer } from '@/offline/roster'
import { tr } from '../text'

/**
 * What the gate may buy from him: each of his cultivations the office marked ready for harvest
 * (the roster carries only those) whose crop has a published rate card. None → nothing today.
 */
export function buyableCultivations(
  roster: { farmers: RosterFarmer[]; rateCards: { crop_id: string }[] },
  farmerId: string,
): RosterFarmer['cultivations'] {
  const farmer = roster.farmers.find((f) => f.user_id === farmerId)
  const priced = new Set(roster.rateCards.map((c) => c.crop_id))
  return (farmer?.cultivations ?? []).filter((c) => priced.has(c.crop_id))
}

/** "2.5 एकड़" / "2.5 acre"; null when the plot has no area. */
export function areaText(area: unknown, unit: string | null | undefined): string | null {
  const n = typeof area === 'number' ? area : Number(area)
  if (area === null || area === undefined || area === '' || !Number.isFinite(n) || n <= 0)
    return null
  const u = (unit ?? '').toUpperCase()
  const word =
    u === 'ACRE'
      ? tr('gate.v1.crop.acre')
      : u === 'HECTARE'
        ? tr('gate.v1.crop.hectare')
        : u.toLowerCase()
  return `${Number(n.toFixed(2))} ${word}`.trim()
}
